<!--<template>
  <v-content>
    <v-container>
       <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h1 class="subheading grey--text">Forgot Password</h1>
     
      <p>Enter your email below to receive a link to create a new password.</p>
      <v-form @keyup.native.enter="emailRequest">
        <v-text-field label="Email Address" solo v-model="email" :rules="emailRules" required></v-text-field>

        <v-btn
          color="success"
          class="mr-4"
          type="submit"
          @click="emailRequest"
        >Get Password Change Email</v-btn>
      </v-form>
    </v-container>
  </v-content>
</template>--> 
<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="emailRequest">
                <card type="login">
                  <div
                    class="alert alert-dismissible fade show"
                    :class="alertType"
                    v-if="showAlert==true"
                  >
                    <button
                      type="button"
                      aria-hidden="true"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <i class="nc-icon nc-simple-remove"></i>
                    </button>

                    <div>
                      <span>{{alertMsg}}</span>
                    </div>
                  </div>
                  <h3 slot="header" class="header text-center">Reset Password</h3>

                  <fg-input
                    v-model="email"
                    addon-left-icon="nc-icon nc-single-02"
                    placeholder="Email"
                  ></fg-input>

                  <!-- <p-checkbox>Subscribe to newsletter</p-checkbox> -->

                  <p-button
                    native-type="submit"
                    slot="footer"
                    type="info"
                    round
                    block
                    class="mb-3"
                  >Submit</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg) "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "@/components/Dashboard/Views/Pages/Layout/AppNavbar";
import AppFooter from "@/components/Dashboard/Views/Pages/Layout/AppFooter";
import firebase, { functions } from "firebase";
import { mapGetters } from "vuex";
export default {
  name: "emailVerify",
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      alertMsg: "",
      alertType: "",
      displayAlert: false,
      showAlert: false
    };
  },
  methods: {
    emailRequest: function(e) {
      let self = this;
      e.preventDefault();
      console.log(this.email);
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(function() {
          // Email sent.
          self.alertMsg = "Please check your email for reset instructions";
          self.showAlert = true;
          self.alertType = "alert-success";
        })
        .catch(err => {
          console.log("There was an error: ", err);
          if (err.code === "auth/invalid-email") {
            self.alertMsg = "Please enter a valid email.";
            self.showAlert = true;

            self.alertType = "alert-danger";
            return;
          }
          if (err.code === "auth/user-not-found") {
            self.alertMsg = "Please enter a valid email.";
            self.showAlert = true;
            self.alertType = "alert-danger";
            return;
          }

          self.showAlert = true;

          self.alertType = "alert-danger";
        });
    }
  }
};
</script>
<style scoped>
</style>